/* eslint-disable import/prefer-default-export */
/**
 * @param {Record<string, unknown>} fieldsValue
 * @returns {Record<string, unknown>}
 */
export function trimFormFieldValues(fieldsValue) {
  return Object.keys(fieldsValue).reduce((acc, key) => {
    const raw = fieldsValue[key];
    acc[key] = raw && typeof raw === 'string' ? raw.trim() : raw;
    return acc;
  }, {});
}
